/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserNewsletterUpdateRequest} from '../models/UserNewsletterUpdateRequest';

export interface UserNewsletterUpdate$Request {
    userId: number;
    userNewsletterUpdateRequest: UserNewsletterUpdateRequest;
}

export interface UserNewsletterUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userNewsletterUpdateRequest = createAction<PayloadData<void, UserNewsletterUpdate$Request>>('USER_NEWSLETTER_UPDATE__USER_NEWSLETTER_UPDATE__REQUEST');
export const userNewsletterUpdateSuccess = createAction<PayloadData<void, UserNewsletterUpdate$Request>>('USER_NEWSLETTER_UPDATE__USER_NEWSLETTER_UPDATE__SUCCESS');
export const userNewsletterUpdateFailure = createAction<PayloadData<Error, UserNewsletterUpdate$Request, true>>('USER_NEWSLETTER_UPDATE__USER_NEWSLETTER_UPDATE__FAILURE');

export const userNewsletterUpdateActions = [
    userNewsletterUpdateRequest,
    userNewsletterUpdateSuccess,
    userNewsletterUpdateFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserNewsletterUpdateRequest} meta.userNewsletterUpdateRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userNewsletterUpdate = (meta: UserNewsletterUpdate$Request, config?: UserNewsletterUpdate$Config) => {
    return {
        CALL_API: {
            types: userNewsletterUpdateActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/newsletters`,
            TRANSPORT_REQUEST_BODY: meta.userNewsletterUpdateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

